import { Paper, Box, Typography } from "@mui/material";
import {
  AccessTime,
  CheckCircle,
  Replay,
  Autorenew,
} from "@mui/icons-material";

const getStatusIcon = (status) => {
  const iconProps = { fontSize: "small" };

  switch (status) {
    case "pending":
      return <AccessTime {...iconProps} />;
    case "processed":
    case "completed":
      return <CheckCircle {...iconProps} />;
    case "processing":
      return <Autorenew {...iconProps} />;
    case "refunded":
      return <Replay {...iconProps} />;
    default:
      return null;
  }
};
export const BoxListTile = ({ status, primary, secondary }) => (
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      p: 0.4,
      borderRadius: 2,
      backgroundColor: "transparent",
      transition: "background-color 0.2s",
      "&:hover": { bgcolor: "primary.light" },
    }}
  >
    <Box display="flex" alignItems="center" gap={1}>
      {getStatusIcon(status)}
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {primary}
      </Typography>
    </Box>
    <Typography variant="body2" sx={{ fontWeight: 600 }}>
      {secondary}
    </Typography>
  </Paper>
);
